import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { Mixpanel } from "../../../../actions/mixpanel.actions";
import * as projectActions from "../../../../actions/project.actions";
import * as skillsActions from "../../../../actions/skills.actions";

import ProjectReview from "../components/ProjectReview";

const steps = projectId => [
  {
    caption: "Basics",
    url: `/company/project/id/${projectId}/basics`
  },
  {
    caption: "Details",
    url: `/company/project/id/${projectId}/details`
  },
  {
    caption: "Skills",
    url: `/company/project/id/${projectId}/skills`
  },
  {
    caption: "Budget",
    url: `/company/project/id/${projectId}/budget`
  },
  {
    caption: "Review",
    url: `/company/project/id/${projectId}/review`
  }
];

class ProjectReviewContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAdmin: localStorage.getItem("role") === "admin" ? true : false,
      isVerified: localStorage.getItem("verified") === "true" ? true : false,
      draftUrl:
        localStorage.getItem("role") === "admin"
          ? "/admin/projects"
          : "/company/projects"
    };

    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    this.props.projectActions.getProject(this.props.match.params.projectId);
    this.props.skillsActions.fetchSkills();
  }

  handleClick() {
    const adminEdit = false;
    const loading = true;

    // Track Mixpanel event
    Mixpanel.track("Project Creation - Review - Submit For Approval");

    if (this.state.isVerified || this.state.isAdmin) {
      const payload = {
        status_id: 2
      };

      this.props.projectActions.updateProject(
        payload,
        "/company/projects",
        this.props.match.params.projectId,
        adminEdit,
        loading
      );
    } else {
      this.props.history.push({
        pathname: "/company/verify-account",
        state: { projectId: this.props.match.params.projectId }
      });
    }
  }

  render() {
    return this.props.project ? (
      <ProjectReview
        draftUrl={this.state.draftUrl}
        project={this.props.project}
        skills={this.props.skills.data}
        steps={steps(this.props.match.params.projectId)}
        handleClick={this.handleClick}
      />
    ) : null;
  }
}

const mapStateToProps = state => {
  return {
    project: state.project.data.data,
    skills: state.skills.skills
  };
};

const mapDispatchToProps = dispatch => {
  return {
    projectActions: bindActionCreators(projectActions, dispatch),
    skillsActions: bindActionCreators(skillsActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectReviewContainer);



// WEBPACK FOOTER //
// ./src/routes/employer/project/containers/ProjectReviewContainer.js